(function () {
  'use strict';

  var hasPlants = false;
  var stateLoaded = false;
  var refreshTimer = null;
  var lastPlanner = null;
  var lastPersistedState = null;
  var applying = false;

  function planner() {
    return document.getElementById('AowDeliveryPlanner');
  }

  function dateButtons() {
    var root = planner();
    return root ? Array.prototype.slice.call(root.querySelectorAll('.aow-calendar__day')) : [];
  }

  function restorePlantDelay() {
    dateButtons().forEach(function (button) {
      if (button.dataset.aowPlantDelay !== 'true') return;
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      if (button.getAttribute('title') === 'Plants require one additional valid fulfilment day') {
        button.removeAttribute('title');
      }
      button.classList.remove('is-aow-plant-delay');
      if (button.dataset.type !== 'unavailable') button.classList.remove('is-unavailable');
      delete button.dataset.aowPlantDelay;
    });
  }

  function setNoticeVisible(visible) {
    var root = planner();
    if (!root) return;

    var notice = document.getElementById('AowPlantLeadTimeNotice');
    if (!notice && visible) {
      notice = document.createElement('div');
      notice.id = 'AowPlantLeadTimeNotice';
      notice.className = 'aow-plant-lead-time-notice';
      notice.setAttribute('role', 'status');
      notice.innerHTML = '<strong>Plant lead time applied</strong><br>This basket contains plants, so the earliest available fulfilment date is one valid day later than our standard flower lead time.';
      var calendar = root.querySelector('.aow-calendar') || root;
      calendar.parentNode.insertBefore(notice, calendar);
    }

    if (notice) notice.hidden = !visible;
  }

  function selectedIso() {
    var input = document.getElementById('AowDateIsoInput');
    return input && input.value ? input.value : '';
  }

  function clearInvalidSelection(delayedButton) {
    if (!delayedButton || selectedIso() !== delayedButton.dataset.date) return;

    delayedButton.classList.remove('is-selected');
    var requested = document.getElementById('AowDateInput');
    var iso = document.getElementById('AowDateIsoInput');
    if (requested) requested.value = '';
    if (iso) iso.value = '';

    var checkout = document.getElementById('checkout');
    if (checkout) {
      checkout.disabled = true;
      checkout.setAttribute('aria-disabled', 'true');
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: {
        'AOW Requested Date': '',
        'AOW Date ISO': '',
        'AOW Contains Plants': 'Yes'
      } })
    }).catch(function () {});
  }

  function persistPlantState() {
    if (!stateLoaded || lastPersistedState === hasPlants) return;
    lastPersistedState = hasPlants;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { 'AOW Contains Plants': hasPlants ? 'Yes' : 'No' } })
    }).catch(function () { lastPersistedState = null; });
  }

  function syncRecommendationValidity() {
    var root = planner();
    if (!root) return;

    var recommendedButtons = dateButtons().filter(function (button) {
      return button.classList.contains('is-recommended');
    });

    if (!recommendedButtons.length) return;

    var hasInvalidRecommendation = recommendedButtons.some(function (button) {
      return button.disabled || button.dataset.type === 'unavailable';
    });

    if (!hasInvalidRecommendation) return;

    recommendedButtons.forEach(function (button) {
      button.classList.remove('is-recommended');
      if (button.getAttribute('title') === 'Recommended date based on your event') {
        button.removeAttribute('title');
      }
    });

    var recommendation = document.getElementById('AowRecommendation');
    var title = document.getElementById('AowRecommendationTitle');
    var text = document.getElementById('AowRecommendationText');

    if (!recommendation || !title || !text || !recommendation.classList.contains('is-visible')) return;

    title.textContent = 'Your event is very soon';
    text.textContent = hasPlants
      ? 'The normal flower recommendation falls before the first valid plant fulfilment date. Please choose from the available dates shown.'
      : 'The normal recommendation falls before the first date currently available to order. Please choose from the available dates shown.';
  }

  function applyPlantRule() {
    if (applying || !stateLoaded || !planner()) return;
    applying = true;

    try {
      restorePlantDelay();
      persistPlantState();

      var root = planner();
      root.dataset.aowHasPlants = hasPlants ? 'true' : 'false';

      if (!hasPlants) {
        setNoticeVisible(false);
        syncRecommendationValidity();
        return;
      }

      var firstAvailable = dateButtons().find(function (button) {
        return button.dataset.type === 'available' && !button.disabled;
      });

      if (firstAvailable) {
        firstAvailable.dataset.aowPlantDelay = 'true';
        firstAvailable.disabled = true;
        firstAvailable.setAttribute('aria-disabled', 'true');
        firstAvailable.setAttribute('title', 'Plants require one additional valid fulfilment day');
        firstAvailable.classList.add('is-unavailable', 'is-aow-plant-delay');
        clearInvalidSelection(firstAvailable);
      }

      setNoticeVisible(true);
      syncRecommendationValidity();
    } finally {
      applying = false;
    }
  }

  function refreshBasePlanner() {
    var eventContinue = document.getElementById('AowEventContinue');
    var eventInput = document.getElementById('AowEventDate');
    if (!eventContinue || !eventInput || !eventInput.value) return;

    window.setTimeout(function () {
      eventContinue.click();
    }, 0);
  }

  function useEmbeddedPlantState() {
    if (typeof window.AOW_CART_HAS_PLANTS !== 'boolean') return false;

    hasPlants = window.AOW_CART_HAS_PLANTS;
    stateLoaded = true;
    applyPlantRule();
    return true;
  }

  function cartContainsPlants(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      var productType = String(item && item.product_type ? item.product_type : '').toLowerCase();
      return productType.indexOf('plant') !== -1;
    });
  }

  function loadPlantState() {
    if (!planner()) return;

    fetch('/cart.js?_=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Current cart could not be loaded');
        return response.json();
      })
      .then(function (cart) {
        var previousHasPlants = stateLoaded ? hasPlants : null;
        hasPlants = cartContainsPlants(cart);
        window.AOW_CART_HAS_PLANTS = hasPlants;
        stateLoaded = true;
        applyPlantRule();

        if (previousHasPlants === true && hasPlants === false) {
          refreshBasePlanner();
        }
      })
      .catch(function (error) {
        console.warn('AOW plant lead-time check could not be refreshed.', error);
      });
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(loadPlantState, 180);
  }

  function mutationTouchesCart(mutation) {
    var target = mutation && mutation.target;
    if (
      target &&
      target.nodeType === 1 &&
      target.closest &&
      target.closest('cart-items, #main-cart-items, .cart-items')
    ) {
      return true;
    }

    var nodes = Array.prototype.slice.call((mutation && mutation.addedNodes) || [])
      .concat(Array.prototype.slice.call((mutation && mutation.removedNodes) || []));

    return nodes.some(function (node) {
      if (!node || node.nodeType !== 1) return false;
      if (node.matches && node.matches('cart-items, #main-cart-items, .cart-items')) return true;
      return !!(
        node.querySelector &&
        node.querySelector('cart-items, #main-cart-items, .cart-items')
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (useEmbeddedPlantState()) {
      scheduleRefresh();
    } else {
      loadPlantState();
    }

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('cart-items, #main-cart-items, .cart-items')) {
        scheduleRefresh();
      }
    });

    document.addEventListener('click', function (event) {
      var checkout = event.target && event.target.closest ? event.target.closest('#checkout') : null;
      if (!checkout || !hasPlants) return;
      var delayed = document.querySelector('.aow-calendar__day[data-aow-plant-delay="true"]');
      if (delayed && selectedIso() === delayed.dataset.date) {
        event.preventDefault();
        event.stopImmediatePropagation();
        clearInvalidSelection(delayed);
        setNoticeVisible(true);
      }
    }, true);

    var observer = new MutationObserver(function (mutations) {
      var currentPlanner = planner();
      if (currentPlanner !== lastPlanner) {
        lastPlanner = currentPlanner;
        scheduleRefresh();
        return;
      }

      if (mutations.some(mutationTouchesCart)) {
        scheduleRefresh();
        return;
      }

      if (stateLoaded && currentPlanner) {
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(applyPlantRule, 50);
      }
    });

    lastPlanner = planner();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();